enum GroupType {
	Travvant = "Travvant",
	Independent = "Independent",
	Combo = "Combo"
}

export default GroupType;
